module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.showAssignStoresModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Assign Stores To Group '" + _vm._s(_vm.groupDetails.name) + "'")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body relative-block",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('loading-screen', {
    attrs: {
      "show": _vm.displaySpinner,
      "color": '#2C3E50',
      "display": 'inline'
    }
  }), _vm._v(" "), (!_vm.displaySpinner) ? _c('select-locations-popup', {
    attrs: {
      "previouslySelected": _vm.groupLocations,
      "withButton": false
    },
    on: {
      "selectedLocations": _vm.selectStores
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.assignStoresToGroup()
      }
    }
  }, [_vm._v("Assign")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ed7d18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/StoreManager/AssignStores.vue
// module id = 705
// module chunks = 0